import React from "react";
import coverImage from "../../images/docker-deep-dive.png";

function EBookCover() {
  return (
    <img src={coverImage} alt="Docker Deep Dive - free eBook" className="ebook__image"/>
  );
}

export default EBookCover;
